<div class="global-search" [class.hide]="!showSearch">
  <div class="search-wrapper">
    <div class="search">
      <span class="title">
        {{ 'ACTIONS.SEARCH' | translate }}
      </span>
      <span
        class="close"
        role="button"
        tabindex="0"
        (keydown)="showSearch = false; onHideSearch.emit()"
        (click)="showSearch = false; onHideSearch.emit()">
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg">
          <path
            _ngcontent-ng-c1320985669=""
            d="M13.6582 14.4531C13.4004 14.7109 12.9277 14.7109 12.6699 14.4531L6.99805 8.73828L1.2832 14.4531C1.02539 14.7109 0.552734 14.7109 0.294922 14.4531C0.0371094 14.1953 0.0371094 13.7227 0.294922 13.4648L6.00977 7.75L0.294922 2.07812C0.0371094 1.82031 0.0371094 1.34766 0.294922 1.08984C0.552734 0.832031 1.02539 0.832031 1.2832 1.08984L6.99805 6.80469L12.6699 1.08984C12.9277 0.832031 13.4004 0.832031 13.6582 1.08984C13.916 1.34766 13.916 1.82031 13.6582 2.07812L7.94336 7.75L13.6582 13.4648C13.916 13.7227 13.916 14.1953 13.6582 14.4531Z"
            fill="#005046"></path>
        </svg>
      </span>
    </div>
    <div class="search-box">
      <input
        type="text"
        class="awqaf-input search-control"
        [placeholder]="('ACTIONS.SEARCH' | translate) + ' ...'" />
      <img [dir]="currentDir" src="assets/icons/search-gray.svg" alt="search" />
    </div>
  </div>

  <div class="search-overlay"></div>
</div>
